import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Message.css";
import user1Img from "../assets/traveller.png";
import user2Img from "../assets/guide.png";
import { FaSearch, FaEnvelope, FaCalendarAlt, FaHotel, FaWalking, FaChevronRight } from "react-icons/fa";
import NavUser from "../components/NavUser";
import { getApiBaseUrl } from "../utils/apiConfig";

function Messages() {
  const [search, setSearch] = useState("");
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const API_URL = getApiBaseUrl();

  useEffect(() => {
    const fetchConversations = async () => {
      try {
        const token = localStorage.getItem("jwt_token");
        if (!token) return;

        const response = await axios.get(
          `${API_URL}/conversations`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setConversations(response.data);
      } catch (err) {
        console.error("Error fetching conversations:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchConversations();
  }, [API_URL]);

  const filteredConversations = conversations.filter((conv) => {
    const name = conv.participants?.[0]?.full_name?.toLowerCase() || "";
    const bookingId =
      conv.booking?.id?.toString() ||
      conv.tour_booking?.id?.toString() ||
      conv.context_entity_id?.toString() ||
      "";
    const eventTitle = conv.event?.title?.toLowerCase() || "";
    return (
      name.includes(search.toLowerCase()) ||
      bookingId.includes(search.toLowerCase()) ||
      eventTitle.includes(search.toLowerCase())
    );
  });

  const handleMessageClick = (conv) => {
    console.log("Clicked conversation:", conv);
    navigate(`/chat/${conv.id}`, {
      state: {
        bookingId: conv.booking?.id || conv.tour_booking?.id || conv.context_entity_id,
        isClosed: conv.isClosed,
        participant: conv.participants[0],
        contextType: conv.context_entity_type,
        contextTitle:
          conv.booking?.listing?.title ||
          conv.booking?.listing?.name ||
          conv.tour_booking?.tour_listing?.title ||
          conv.event?.title ||
          "Reservation Chat",
        checkoutDate: conv.booking?.checkout_date,
        bookingDate: conv.tour_booking?.booking_date,
      },
    });
  };

  if (loading) return <div className="loading">Loading conversations...</div>;

  return (
    <div className="agent-page">
      <NavUser />
      
      <div className="agent-hero">
        <div className="agent-hero-overlay" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1600&q=80')` }} />
        <div className="agent-hero-content">
          <h1>Messages</h1>
          <p>Connect with your guides, hosts, and organizers to plan your perfect trip.</p>
        </div>
      </div>

      <div className="agent-container">
        <div className="messages-card-layout">
          <div className="messages-sidebar-tools">
            <div className="search-box-premium">
              <FaSearch />
              <input
                type="text"
                placeholder="Search by name, event, or booking ID..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            
            <div className="message-filter-stats">
              <div className="filter-stat">
                <span className="stat-label">Total Chats</span>
                <span className="stat-value">{conversations.length}</span>
              </div>
              <div className="filter-stat">
                <span className="stat-label">Unread</span>
                <span className="stat-value unread-count">
                  {conversations.filter(c => !c.isRead).length}
                </span>
              </div>
            </div>
          </div>

          <div className="messages-list-premium">
            {filteredConversations.length === 0 ? (
              <div className="no-messages-placeholder">
                <FaEnvelope />
                <p>No conversations found matching your search.</p>
              </div>
            ) : (
              filteredConversations.map((conv) => {
                const participant = conv.participants?.[0];
                const isRead = conv.isRead;
                const isClosed = conv.isClosed;
                const bookingId = conv.booking?.id || conv.tour_booking?.id || conv.context_entity_id || "N/A";
                const isTour = conv.context_entity_type === "tour_booking";
                const isEvent = conv.context_entity_type === "event_booking";
                const title =
                  conv.booking?.listing?.name ||
                  conv.booking?.listing?.title ||
                  conv.tour_booking?.tour_listing?.title ||
                  conv.event?.title ||
                  "Untitled";
                const lastMessage = conv.last_message || "No messages yet";
                const lastMessageTime = conv.last_message_at
                  ? new Date(conv.last_message_at).toLocaleDateString()
                  : "";

                return (
                  <div
                    key={conv.id}
                    className={`message-card-premium ${!isRead ? "is-unread" : ""} ${isClosed ? "is-closed" : ""}`}
                    onClick={() => handleMessageClick(conv)}
                  >
                    <div className="card-avatar">
                      <img
                        src={participant?.role === "Guide" ? user2Img : user1Img}
                        alt={participant?.full_name}
                      />
                      {!isRead && <div className="unread-dot" />}
                    </div>

                    <div className="card-main-content">
                      <div className="card-header-row">
                        <h4 className="participant-name">{participant?.full_name}</h4>
                        <span className="last-time">{lastMessageTime}</span>
                      </div>

                      <div className="card-context-row">
                        <span className={`context-badge ${isTour ? "tour-badge" : isEvent ? "event-badge" : "hotel-badge"}`}>
                          {isTour ? <FaWalking /> : isEvent ? <FaCalendarAlt /> : <FaHotel />} {title}
                        </span>
                        <span className="booking-id-tag">ID: #{bookingId}</span>
                      </div>

                      <div className="card-message-preview">
                        {lastMessage}
                      </div>
                    </div>

                    <div className="card-status-indicator">
                      {isClosed ? (
                        <span className="status-label closed">Closed</span>
                      ) : (
                        <span className="status-label active">Active</span>
                      )}
                      <FaChevronRight className="arrow-icon" />
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Messages;
